export const PRODUCTS = [
  {
    Id: 1394,
    Name: 'Polo Shirt',
    TypeName: 'Polo',
    Thumbnail: '/media/nowejdxj/thumb-polo1.jpg?width=120px&height=120px',
    Texture: [
      '/media/xm1h3bg3/4k-maccax_polo_low_v01_defaultmat_diffuse.jpg?width=100px',
      '/media/xm1h3bg3/4k-maccax_polo_low_v01_defaultmat_diffuse.jpg?width=2048px',
    ],
    Mesh: '/media/kp2enujb/polo_mesh.obj',
    Description: 'Polo Shirt',
    ShortDescription: 'Polo Shirt',
    Price: '0',
    TextureNormal: '/media/ofwpbug1/4k-maccax_polo_low_v01_defaultmat_normal.jpg',
    Styles: [
      {
        StyleColor: '#ffffff',
        Patterns: [
          {
            PatternName: 'WHITE',
            PatternTexture: [
              '/media/xm1h3bg3/4k-maccax_polo_low_v01_defaultmat_diffuse.jpg?width=100px',
              '/media/xm1h3bg3/4k-maccax_polo_low_v01_defaultmat_diffuse.jpg',
            ],
            PatternThumbnail: '/media/nowejdxj/thumb-polo1.jpg?width=50px&height=50px',
          },
        ],
      },
    ],
    PartOpacities: null,
  },
  {
    Id: 1922,
    Name: 'Regna Art Tri Suit',
    TypeName: '',
    Thumbnail: '/media/xkdpzeah/screenshot186a.png?width=120px&height=120px',
    Texture: [
      '/media/lnqneo5v/woman_suit01_out_diffuse_v03.png?width=100px',
      '/media/lnqneo5v/woman_suit01_out_diffuse_v03.png?width=2048px',
    ],
    Mesh: '/media/lh3l32w4/trisuit_art_woman.obj',
    Description: 'Regna Art Tri Suit',
    ShortDescription: '',
    Price: '0',
    TextureNormal: '/media/ftlbnufl/woman_suit01_out_normal.png',
    Styles: null,
    PartOpacities: null,
  },
  {
    Id: 1941,
    Name: 'T-Shirt',
    TypeName: '',
    Thumbnail: '/media/lqbkanij/untitled_camera_view02.png?width=120px&height=120px',
    Texture: ['/media/frsml3jw/white.jpg?width=100px', '/media/frsml3jw/white.jpg?width=2048px'],
    Mesh: '/media/fuunuzqy/t-shirt_regna03.obj',
    Description: 'T-Shirt',
    ShortDescription: '',
    Price: '0',
    TextureNormal:
      '/media/pemhlhmq/t-shirt_tesla_04_t_shirt_mesh_t_shirt_mesh_test01_mesh_initialshadinggroup_normal.jpg',
    Styles: null,
    PartOpacities: null,
  },
  {
    Id: 1550,
    Name: 'Men Tri Suit',
    TypeName: 'Triathlon',
    Thumbnail: '/media/2cfn4nzl/screenshot001.png?width=120px&height=120px',
    Texture: [
      '/media/pgxnueub/men_low_zbr_initialshadinggroup_diffuse.jpg?width=100px',
      '/media/pgxnueub/men_low_zbr_initialshadinggroup_diffuse.jpg?width=2048px',
    ],
    Mesh: '/media/4emjlr3s/men_web.obj',
    Description: 'Men Tri Suit',
    ShortDescription: '',
    Price: '0',
    TextureNormal: '/media/zdudgdaz/men_low_zbr_initialshadinggroup_normal.jpg',
    Styles: null,
    PartOpacities: null,
  },
  {
    Id: 1554,
    Name: 'Women Tri Suit',
    TypeName: 'Triathlon',
    Thumbnail: '/media/3bcbljtx/screenshot000.png?width=120px&height=120px',
    Texture: [
      '/media/2xbbcba0/suit_wmen_low01_initialshadinggroup_diffuse.jpg?width=100px',
      '/media/2xbbcba0/suit_wmen_low01_initialshadinggroup_diffuse.jpg?width=2048px',
    ],
    Mesh: '/media/zaeiccjw/woman_web.obj',
    Description: 'Women Tri Suit',
    ShortDescription: '',
    Price: '0',
    TextureNormal: '/media/nnjlbry0/suit_wmen_low01_initialshadinggroup_normal.jpg',
    Styles: null,
    PartOpacities: null,
  },
];
